/**
 * The card's overdue native Engine debts (activation plan I-22).
 *
 *   GET /api/cards/:cardId/native-engine-debt   { debts: NativeEngineDebt[] }
 *
 * The gateway answers `{ debts: [] }` while NATIVE_CURRENT_ENGINE_ENABLED is
 * off, and 503 when it could not read (never an empty list for "could not ask").
 */
import { z } from 'zod';

import { apiJson } from './client';

export const nativeEngineDebtSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  since: z.string(),
  escalatedAt: z.string().nullable(),
  endpoint: z.string().nullable(),
  kind: z.enum(['engine_http', 'host_fs']),
});
export type NativeEngineDebt = z.infer<typeof nativeEngineDebtSchema>;
const responseSchema = z.object({ debts: z.array(nativeEngineDebtSchema) });

export const nativeEngineDebtKeys = {
  forCard: (cardId: string) => ['native-engine-debt', cardId] as const,
};

export const nativeEngineDebtApi = {
  forCard(cardId: string): Promise<NativeEngineDebt[]> {
    return apiJson<unknown>(`/cards/${encodeURIComponent(cardId)}/native-engine-debt`).then(
      (r) => responseSchema.parse(r).debts,
    );
  },
};
